import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded components
const AddEditProcedure = Loadable(lazy(() => import("../AddEditProcedure")));
const NewProcedureDashboard = Loadable(lazy(() => import("../NewProcedureDashboard")));
const List = Loadable(lazy(() => import("../../molecules/List")));
const Folder = Loadable(lazy(() => import("../../molecules/Folder")));
const Detail = Loadable(lazy(() => import("../../molecules/Detail")));
const YearList = Loadable(lazy(() => import("../../molecules/YearList")));

const procedureRoutes = [
  {
    path: "standards",
    children: [
      { path: "addEdit-procedure", element: <AddEditProcedure /> },
      //for new dynamic procedure dashboard
      { path: "procedure-dashboard", element: <NewProcedureDashboard /> },
      {
        path: "procedure-list",
        element: (
          <List
            moduleType="procedure"
            limit={30}
            name="Procedure"
            navigateUrl="procedure-details"
          />
        )
      },
      {
        path: "procedure-detail-year/:documentId/:type?",
        element: (
          <YearList
            moduleType="procedure"
            name="Procedure"
            navigateUrl="procedure-type"
          />
        )
      },
      {
        path: "procedure-type/:documentId",
        element: (
          <Folder
            moduleType="procedure"
            name="Procedure"
            detailUrl="procedure-type"
            yearUrl="procedure-detail-year"
          />
        )
      },
      {
        path: "procedure-type/:documentId/:type?/:year?",
        element: <Detail moduleType="procedure" name="Procedure" />
      }
    ]
  }
];

export default procedureRoutes;
